// ═══════════════════════════════════════════════════════════════
// ClearView CRM Contact Log Types
// v1.5.2 — Added coffee, lunch, volunteering, donation types
//         Added direction support (inbound/outbound toggle)
//
// Types with hasDirection: true show the inbound/outbound toggle
// Types with hasDirection: false are inherently inbound (always score)
// ═══════════════════════════════════════════════════════════════

// ── Contact Purpose flags (multi-select) ──
export const CONTACT_PURPOSES = [
  { id: "gift_proposal", name: "Gift Proposal", color: "#8b5cf6" },
  { id: "gift_renewal", name: "Gift Renewal", color: "#16a34a" },
  { id: "cultivation", name: "Cultivation", color: "#f59e0b" },
  { id: "invitation", name: "Invitation", color: "#3b82f6" },
  { id: "gratitude", name: "Gratitude", color: "#ec4899" },
];

export const CONTACT_LOG_TYPES = [
  {
    id: "email",
    name: "Email",
    icon: "Mail",
    color: "#3b82f6",
    hasDirection: true,
  },
  {
    id: "phone",
    name: "Phone Call",
    icon: "PhoneCall",
    color: "#10b981",
    hasDirection: true,
  },
  {
    id: "text",
    name: "Text",
    icon: "MessageSquare",
    color: "#f59e0b",
    hasDirection: true,
  },
  {
    id: "meeting",
    name: "Meeting",
    icon: "Users",
    color: "#8b5cf6",
    hasDirection: false,
  },
  {
    id: "coffee",
    name: "Coffee",
    icon: "Coffee",
    color: "#92400e",
    hasDirection: false,
  },
  {
    id: "lunch",
    name: "Lunch",
    icon: "UtensilsCrossed",
    color: "#dc2626",
    hasDirection: false,
  },
  {
    id: "event",
    name: "Event",
    icon: "Calendar",
    color: "#ef4444",
    hasDirection: false,
  },
  {
    id: "volunteering",
    name: "Volunteering",
    icon: "Heart",
    color: "#ec4899",
    hasDirection: false,
  },
  {
    id: "donation",
    name: "Donation",
    icon: "Gift",
    color: "#16a34a",
    hasDirection: false,
  },
  {
    id: "note",
    name: "Note",
    icon: "FileText",
    color: "#6b7280",
    hasDirection: false,
  },
  {
    id: "card",
    name: "Card / Mail",
    icon: "Send",
    color: "#0d9488",
    hasDirection: false,
  },
  {
    id: "portfolio_move",
    name: "Portfolio Move",
    icon: "ArrowRightCircle",
    color: "#0ea5e9",
    hasDirection: false,
  },
];
